var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoteOnDecision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.26 15.35c0 .38.312.692.692.692h3.585l-.46 2.193a.773.773 0 0 0 .21.712l.55.55 3.414-3.414a1.03 1.03 0 0 0 .304-.733v-4.49c0-.574-.463-1.038-1.036-1.038h-4.666c-.428 0-.798.26-.954.632l-1.565 3.657a1.038 1.038 0 0 0-.073.376v.864z",
    fill: "#F4FFFB",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.579 8.993a.693.693 0 0 0-.692-.69H9.303l.46-2.194a.773.773 0 0 0-.21-.712l-.55-.55L5.588 8.26a1.032 1.032 0 0 0-.304.732v4.492c0 .573.463 1.036 1.037 1.036h4.666c.428 0 .797-.259.954-.632l1.565-3.655c.045-.117.073-.242.073-.377v-.864z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteOnDecision);
export default __webpack_public_path__ + "static/media/voteOnDecision.72028ba85d67ff98db7bef46934c7c74.svg";
export { ForwardRef as ReactComponent };